import React, { useState, useEffect } from 'react';

const AudioControls = ({ sendTextToAPI, audio, loading, setLoading, handleSliderChange, handleSliderChangeEnd, isAudioPlaying, setIsAudioPlaying }) => {
  const [speed, setSpeed] = useState(1.0);

  const handleSpeedChange = (e) => {
    const newSpeed = e.target.value;
    setSpeed(newSpeed);
    if (audio) {
      audio.playbackRate = parseFloat(newSpeed);
    }
  };

  // Track audio loading state
  useEffect(() => {
    if (!audio) return;
  
    console.log("🎵 New audio assigned, setting loading to true");
    setLoading(true); // ✅ Start loading when a new audio file is assigned
  
    const handleLoadedMetadata = () => {
      console.log("🔄 Metadata loaded, stopping spinner");
      setLoading(false); // ✅ Stop loading as soon as metadata is available
    };
  
    const handleError = () => {
      console.error("❌ Audio failed to load, stopping spinner");
      setLoading(false);
    };
  
    audio.addEventListener("loadedmetadata", handleLoadedMetadata);
    audio.addEventListener("error", handleError);
  
    return () => {
      audio.removeEventListener("loadedmetadata", handleLoadedMetadata);
      audio.removeEventListener("error", handleError);
    };
  }, [audio]); // ✅ Runs only when a new audio file is assigned  
  
const handlePlayPause = () => {
  if (!audio) return;

  if (isAudioPlaying) {
    audio.pause();
    setIsAudioPlaying(false);
  } else {
    audio.play().then(() => {
      setIsAudioPlaying(true);
    }).catch((error) => {
      console.error("Playback blocked on mobile:", error);
      alert("Tap anywhere on the screen first, then press play.");
    });
  }
};
  

  // Set playback speed after new audio is generated
  useEffect(() => {
    if (audio) {
      audio.playbackRate = speed;
    }
  }, [audio, speed]);

  return (
<div className="audio-controls">
    {/* Progress Bar - Positioned Above Play Button */}
    <div className="progress-container">
        <input
            type="range"
            id="progress-bar"
            value={audio ? audio.currentTime : 0}
            max={audio && !isNaN(audio.duration) ? audio.duration : 0}
            onChange={handleSliderChange}
            onMouseUp={handleSliderChangeEnd}
            onTouchEnd={handleSliderChangeEnd}
        />
    </div>

    {/* 🔹 Wrapper for Play Button & Speed Select */}
    <div className="play-speed-wrapper">
        {/* Play Button */}
        <button className={`play-button ${loading ? 'loading' : ''}`} 
            onClick={handlePlayPause} 
            disabled={loading}
        >
            <div className="play-button-content">
                {loading ? (
                    <div className="spinner"></div>
                ) : isAudioPlaying ? (
                    // Pause Icon
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
                        <rect x="5" y="4" width="4" height="16" />
                        <rect x="15" y="4" width="4" height="16" />
                    </svg>
                ) : (
                    // Play Icon
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
                        <polygon points="5,3 19,12 5,21" />
                    </svg>
                )}
            </div>
        </button>

        {/* Speed Select - Positioned Down & to the Right */}
        <select className="speed-select" value={speed} onChange={handleSpeedChange}>
            <option value={0.5}>0.5x</option>
            <option value={0.75}>0.75x</option>
            <option value={1.0}>1.0x</option>
            <option value={1.5}>1.5x</option>
            <option value={2.0}>2.0x</option>
        </select>
    </div>
</div>
  );
};

export default AudioControls;